<template>
  <div class="container">
    <div class="top_title">推荐文章</div>
    <div class="scroll_area" style="overflow-y: auto">
      <div class="read_items" style="overflow-y: auto">
        <a v-for="item,index in dataList" :href="item.I_URL" class="item" :key="item.id">
          <div class="left_part">
            <img :src="item.I_ARTICLE_ICON" />
          </div>
          <div class="right_part">
            <p class="title">{{item.I_ARTICLE_TITLE}}</p>
            <p class="remark">{{item.I_DATE}}</p>
          </div>
        </a>
      </div>
    </div>

    <!--底部导航-->
    <Footer :navs="nav"></Footer>
  </div>
</template>

<script>
  import DataRequestFactory from '@/factories/dataRequestFactory.js'
  import Footer from '../components/Footer.vue'
  import weui from 'weui.js'

  export default {
    name: '',
    data () {
      return {
        nav: {
          sy: true,
          jchd: false,
          yyst: false,
          wd: false,
        },
        tabFlag: false,
        dataList: []
      }
    },
    components: {
      Footer
    },
    created() {
      let params = {
        "I_FLAG":"全部",
        "I_SEARCH_FIELD":""
      }
      DataRequestFactory.I070010(params).then((response) => {
        this.dataList = response.dataList
      })
    },
    methods: {
      clickTab(value) {
        if(value == 1) {
          this.tabFlag = false
          let params = {
            "I_FLAG":"全部",
            "I_SEARCH_FIELD":""
          }
          DataRequestFactory.I050010(params).then((response) => {
              this.dataList = response.dataList
          })
        } else {
          this.tabFlag = true
          let params = {
            "I_FLAG":"我的",
            "I_SEARCH_FIELD":""
          }
          DataRequestFactory.I050010(params).then((response) => {
            this.dataList = response.dataList
        })
        }
      }
    },
    mounted() {
      let screenHeight = window.innerHeight;
      let fontSize = getComputedStyle(window.document.documentElement)['font-size']
      let heightDiff = screenHeight - parseInt(fontSize) * 3
      $(".scroll_area").css("height", heightDiff + "px"   )
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  @import '../assets/css/pages/H070010.css';
  @import '../assets/css/common.css';
</style>



// WEBPACK FOOTER //
// src/pages/H070010.vue